import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ViewListComponent } from './view-list/view-list.component';

import { CommonMaterialModule } from "@nrwl/common-material";
import { CommonLibModule } from "@nrwl/common-lib";

@NgModule({
  imports: [CommonModule, CommonMaterialModule, CommonLibModule],
  declarations: [ViewListComponent],
  exports: [ViewListComponent]
})
export class ViewListModule { }
